<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
    <!-- Data Peserta -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-12">
          <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Layanan </label>
            <multiselect
              class="mulit-select"
              label="label"
              placeholder="Pilih Layanan"
              :show-labels="false"
              required
              v-model="layanan"
              @select="pilihLayanan"
              :options="optionLayanan"
            ></multiselect>
          </div>
        </div>
        <div class="col-sm-12 col-xl-6" v-show="layanan.value == 'sertifikasi'">
          <div class="form-group">
            <label for="" class="font-weight-bold" >Pilih Periode</label>
            <multiselect
              class="mulit-select"
              label="label"
              placeholder="Pilih Periode"
              :show-labels="false"
              required
              v-model="periode"
              @select="changePeriode"
              :options="dataTahun"
            ></multiselect>
          </div>
        </div>
        <div class="col-sm-12 col-xl-4" v-show="layanan.value == 'rpl'">
          <div class="form-group">
            <label for="" class="font-weight-bold" >Pilih Periode</label>
            <multiselect
              class="mulit-select"
              label="label"
              placeholder="Pilih Periode"
              :show-labels="false"
              required
              v-model="periode"
              @select="changePeriode"
              :options="dataTahun"
            ></multiselect>
          </div>
        </div>
        <div class="col-sm-12 col-xl-2" v-show="layanan.value == 'pelatihan'">
          <div class="form-group">
            <label for="" class="font-weight-bold" >Pilih Periode</label>
            <multiselect
              class="mulit-select"
              label="labelPeriode"
              placeholder="Pilih Periode"
              :show-labels="false"
              required
              v-model="periodePelatihan"
              @select="changePeriode"
              :options="dataTahunPelatihan"
            ></multiselect>
          </div>
        </div>
        <div class="col-sm-12 col-xl-4" v-show="layanan.value == 'pelatihan'">
            <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Kategori Pelatihan</label>
            <multiselect
                class="multi-select"
                placeholder="Pilih Kategori Pelatihan"
                v-model="kategoriPelatihan"
                :options="options"
                @select="changeKategoriPelatihan"
                :show-labels="false"
            ></multiselect>
            </div>
        </div>      
        <div class="col-sm-12 col-xl-6" v-show="layanan.value == 'pelatihan'">
            <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Pelatihan</label>
            <multiselect
                class="multi-select"
                label="nama_pelatihan"
                placeholder="Pilih pelatihan"
                id="pelatihanSelect"
                :show-labels="false"
                required
                v-model="pelatihan"
                @select="pilihPelatihan"
                :options="dataPelatihan"
            ></multiselect>
            </div>
        </div>
        <div class="col-sm-12 col-xl-4" v-show="layanan.value == 'rpl'">
          <div class="form-group">
            <label for="" class="font-weight-bold">Pilih RPL</label>
            <multiselect
              class="mulit-select"
              label="nama_rpl"
              placeholder="Pilih RPL"
              :show-labels="false"
              required
              v-model="rpl"
              @select="pilihRpl"
              :options="dataRpl"
            ></multiselect>
           
          </div>
        </div> 
        <div class="col-sm-12 col-xl-4" v-show="layanan.value == 'rpl'">
          <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Tipe</label>
            <multiselect
              class="mulit-select"
              label="label"
              placeholder="Pilih Tipe"
              :show-labels="false"
              required
              @select="pilihTipe"
              v-model="tipeLayanan"
              :options="dataTipeLayanan"
            ></multiselect>
           
          </div>
        </div>  
        <div class="col-sm-12 col-xl-6" v-show="layanan.value == 'sertifikasi'">
          <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Sertifikasi</label>
            <multiselect
                class="multi-select"
                label="nama_sertifikasi"
                placeholder="Pilih Sertifikasi"
                :show-labels="false"
                required
                v-model="sertifikasi"
                @select="pilihSertifikasi"
                :options="dataSertifikasi"
                
            ></multiselect>
            </div>
        </div>      

        <div class="col-sm-12 col-xl-12">
          <div style="float:right">
            <button class="btn btn-info mr-2" @click="resetFilter">Reset Filter</button>
            <button class="btn btn-success" @click="filterData">Terapkan Filter</button>
          </div>
        </div>

      </CRow>
      <br>
      <CRow>
         <div class="col-sm-12 col-xl-6">
          <div class="form-group">
            <CSelect
              class="float-left"
              placeholder="Data Per Halaman"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>
        
        <div class="col-sm-12 col-xl-4 ml-auto">
          <div class="form-group">
            <CInput
              class="float-right"
              placeholder="Cari Data .."
              v-model="searchPelatihan"
            />
          </div>
        </div>
      </CRow>
      
      <!-- Modal Detail User -->
      <CModal
        title="Modal title"
        :show.sync="modalDetail"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CRow>
          <div class="modal-body row my-n3">
            <div class="col-5">
              <p class="font-weight-bold">No Anggota</p>
              <p class="font-weight-bold">Nama Anggota</p>
              <p class="font-weight-bold">Email</p>
              <p class="font-weight-bold">No. Handphone</p>
              <p class="font-weight-bold">No. Telepon</p>
            </div>
            <div class="col-7">
              <p>: AGT-1</p>
              <p>: Samantha Wiliam</p>
              <p>: samantha@gmail.com</p>
              <p>: 087837432432</p>
              <p>: 034329423423</p>
            </div>
          </div>
        </CRow>
        <template #header>
          <h6 class="modal-title h5 font-weight-bold">Detail Anggota</h6>
        </template>
        <template #footer>
          <router-link to="/keanggotaan/data-anggota">
            <CButton color="info">Detail</CButton>
          </router-link>
          <CButton @click="modalDetail = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
      <!-- Modal Detail User -->
      <CModal
        title="Modal title"
        :show.sync="modalDetailPeserta"
        :no-close-on-backdrop="true"
        :centered="true"
        size="lg"
      >
        <CRow class="px-3">
          <table class="table table-bordered font-weight-bold">
            <tr>
              <th class="bg-primary" style="width: 40%">No Lapor Pelatihan</th>
              <td>{{ detailPeserta.no_lapor_pelatihan ? detailPeserta.no_lapor_pelatihan : '-' }}</td>
            </tr>            
            <tr>
              <th class="bg-primary" style="width: 40%">Nama Pelatihan</th>
              <td>{{detailPeserta.nama_pelatihan ? detailPeserta.nama_pelatihan : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Tanggal Pendaftaran</th>
              <td>{{detailPeserta.tanggal_daftar ? detailPeserta.tanggal_daftar : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Status Pembayaran</th>
              <td>{{detailPeserta.status_pembayaran ? detailPeserta.status_pembayaran : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Perolehan SKP Terstruktur</th>
              <td>{{detailPeserta.skp ? detailPeserta.skp : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Perolehan SKP Non Terstruktur</th>
              <td>{{detailPeserta.skp ? detailPeserta.skp : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Assesment</th>
              <td>{{detailPeserta.skp ? detailPeserta.skp : '-'}}</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Status Pengisian Kuesioner</th>
              <td class="text-danger font-weight-bold">-</td>
            </tr>
            <tr>
              <th class="bg-primary" style="width: 40%">Status E-Certificate</th>
              <td class="text-success font-weight-bold">-</td>
            </tr>
          </table>
        </CRow>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Detail</h6>
        </template>
        <template #footer>
          <CButton @click="modalDetailPeserta = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data Peserta -->
</template>

<script>
import PeriodeService from "@/services/datamaster/periode.service";
import WorkshopService from "@/services/pelatihan/workshop.service";
import dataPesertaLmsService from '@/services/pelatihan/data-peserta/data-peserta-lms.service';
import MasterSertifikasiRplService from "@/services/rpl/master-rpl.service";

import MasterSertifikasiService from "@/services/sertifikasi/master-sertifikasi.service";
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
import { KategoriAnggota } from "@/mixins/master/KategoriAnggota";

import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false
  },
  {
    key: "no_anggota",
    label: "No Anggota",
    sorter: true,
    filter: false
  },
  {
    key: "nama_lengkap",
    label: "Nama",
    sorter: true,
    filter: false
  },
  {
    key: "tanggal_daftar",
    label: "Tanggal Daftar",
    sorter: true,
    filter: false
  },
  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: true,
    filter: false
  },
  {
    key: "aksi",
    _style: "width: 10% text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  mixins: [
    AlertUtils, 
    Pagination,
    KategoriAnggota
  ],
  filters: {
      date(value) {
        if (!value) return "";
        let options = { year: "numeric", month: "long", day: "numeric" };
        return Intl.DateTimeFormat("id-ID", options).format(value);
      }
    },
  data() {
    return {
      pelatihan : [],
      tipeLayanan : [],
      rpl : [],
      periodePelatihan : [],
      dataTahunPelatihan : [],
      kategoriPelatihan : [],
      dataTipeLayanan : [
          {
              label : "RPL",
              value : "rpl"
          },
          {
              label : "Mata Uji",
              value : "mata_uji_rpl"
          },
          {
              label : "Semua",
              value : "default"
          },
      ],
      layanan : [],
      options: [ 'Pelatihan Webinar', 'Pelatihan Offline'],
      optionLayanan : [
          {
              label  :'Sertifikasi',
              value : 'sertifikasi'
          },
          {
              label  :'RPL',
              value : 'rpl'
          },
          {
              label  :'Pelatihan',
              value : 'pelatihan'
          },
      ],
      formFilter : { 
        layanan : '', 
        tipe : '', 
        filter : '', 
        periode : '', 
        id : ''
      },
      formData: [
        {
          idWorkshopPelatihan: "",
          id_workshop_pelatihan: ""
        }
      ],
      
      periode :'',
      sertifikasi : '',
      kategori_anggota : '',
      dataSertifikasi: [],
      dataRpl: [],
      items: [],
      detailPeserta: {
        id_keanggotaan: "",
        id_user: "",
        id_pelatihan_peserta: "",
        nama_pelatihan: "",
        id_workshop_pelatihan: "",
        no_anggota: "",
        nama_lengkap: "",
        tanggal_daftar: "",
        status_pembayaran: "",
        id_invoice: "",
        created_at: "",
        pelatihan_created_at: "",
        no_lapor_pelatihan: "",
        skp: ""
      },
      dataPelatihan: [],
      dataTahun: [],
      fields,
      details: [],
      status: false,
      myModal: false,
      modalDetail: false,
      modalDetailPeserta: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: []
    };
  },
  components : {
    DateRangePicker
  },

  mounted() {
    
    this.getPeriode();
    this.getPeriodePelatihan();
    // this.getTahun();
  },

  methods: {
    pilihTipe(value) {
        this.formFilter.tipe = value.value
    },
    pilihSertifikasi(value) {
        this.formFilter.id = value.id_sertifikasi
    },
    pilihRpl(value) {
        this.formFilter.id = value.id_sertifikasi_rpl
    },
    pilihPelatihan(value) {
        this.formFilter.id = value.id_workshop_pelatihan
    },
    changeKategoriPelatihan(value) {
    // this.disabledPelatihan = false
      this.getPelatihan(value);
    },
    getPelatihan(value) {
    //   alert(this.kategoriPelatihan)
      var vm = this;
      var  kategori = value
    //   var kategori = vm.kategoriPelatihan;
      if(kategori == "Pelatihan Webinar") {
        WorkshopService.getWebinar(0,1000000,'default','default')
        .then((response) => {
          vm.dataPelatihan = response.data.data.content;
          vm.dataPelatihan.id_workshop_pelatihan = this.dataPelatihan[0].id_workshop_pelatihan
          var data = {
            nama_pelatihan : "Semua",
            id_workshop_pelatihan : "default"
          }
          this.dataPelatihan.unshift(data);
          
        })
        .catch((error) => {
          // comment console console.log(error);
        });
      } else if(kategori == "Pelatihan Offline") {
        WorkshopService.getWorkshop(0,1000000,'default')
        .then((response) => {
          vm.dataPelatihan = response.data.data.content; 
          vm.dataPelatihan.id_workshop_pelatihan = this.dataPelatihan[0].id_workshop_pelatihan
          var data = {
            nama_pelatihan : "Semua",
            id_workshop_pelatihan : "default"
          }
          this.dataPelatihan.unshift(data);
        })
        .catch((error) => {
          // comment console console.log(error);
        });
      } else if(kategori == "Pelatihan LMS") {
        dataPesertaLmsService.getPelatihan(0,1000000,'default')
        .then((response) => {
          vm.dataPelatihan = response.data;
          vm.dataPelatihan.nama_pelatihan = response.data.title;
          var data = {
            nama_pelatihan : "Semua",
            id_workshop_pelatihan : "default"
          }
            this.dataPelatihan.unshift(data);
        })
        .catch((error) => {
          // comment console console.log(error);
        });
      }      
    },
    pilihLayanan(value) {
        this.formFilter.layanan = value.value
        // alert(this.formFilter.layanan)
        if(value.value == 'sertifikasi') {
            this.getSertifikasi()

        } else if(value.value == 'rpl') {
            this.getRpl();
        }
    },
    getPeriodePelatihan( ) {
        // dataTahunPelatihan
        const year = new Date().getFullYear()
        // alert(year);
        for (let index = 0; index < 3; index++) {
            this.dataTahunPelatihan.push(
            {
                labelPeriode: year - index,
                value: year - index,
            }
        );
        }
    },

    filterData() {
        // alert('klik')
        this.$parent.changeData(this.formFilter);
    },
    resetFilter() {
        this.periode = '';
        this.sertifikasi = '';
        this.formFilter.tahun_daftar = new Date().getFullYear()
        $("#filterStatusPembayaran").val("");
    },
    changePeriode(e) {
        // comment console console.log(e.value);
        this.formFilter.periode = e.value
    },
    getPeriode() {
        PeriodeService.getPeriodeSelect()
        .then(response => {
          this.dataTahun = response.data.data
        //   var periode = this.dataTahun.find(el => el.status === '1' );
        //   // comment console console.log("PERIODEEEEE")
        //   
        //   this.periode = {
        //     label : periode.label,
        //   }
        //   this.formFilter.tahun_daftar = periode.value
        //   this.$parent.filterData(this.formFilter);
        }).catch(error => {
          // comment console console.log(error)
        })
      },
   
    filterTanggal(e) {
    //   this.$parent.filterTanggal(e);
    },
    Detail(id_pelatihan_peserta) {
      this.modalDetailPeserta = true;
      this.getDetailPeserta(id_pelatihan_peserta);
    },
    getRpl() {
        MasterSertifikasiRplService.getDataSertifikasiRpl(0, 100000, "default")
        .then((response) => {
          this.dataRpl = response.data.data.content;
          
        
            var data = {
                nama_rpl: 'Semua',
                id_sertifikasi_rpl: 'default'
            }
            this.dataRpl.unshift(data);
            
            // this.formFilter.id_sertifikasi_rpl = this.dataSertifikasi[0].id_sertifikasi_rpl

  
        //   this.$parent.changePelatihan(value);

        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },
    getSertifikasi() {
          MasterSertifikasiService.getSertifikasi(0,100000,'default')
          .then(response => {
              this.dataSertifikasi = response.data.data.content;
              var data = {
                nama_sertifikasi : "Semua Data",
                id_sertifikasi : "default"
              }
              this.dataSertifikasi.push(data);
          })
          .catch(error => {
              // comment console console.log(error);
          });
      },
      getTahun() {
        for (let index = 0; index < 30; index++) {
          this.dataTahun.push({
            labelPeriode : 2020+index,
            value : 2020+index
          })
        }
      },

   

    getTahun() {
        for (let index = 0; index < 30; index++) {
          this.dataTahun.push({
            labelPeriode : 2020+index,
            value : 2020+index
          })
        }
      },

    changePelatihan(value) {
      this.getData("0", this.pageSize, value.id_workshop_pelatihan, this.searchPelatihan);
      this.modelIdWorkshopPelatihan = value.id_workshop_pelatihan;
      // this.getData(e);
    }
  },
  computed: {

  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
